/**
 * @generated SignedSource<<322f64ee829d98362636d8d8d03ba49a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AppBuildAndroidReleaseStatusType = "COMPLETED" | "DRAFT" | "HALTED" | "INPROGRESS" | "%future added value";
export type AppBuildAndroidTrackType = "ALPHA" | "BETA" | "INTERNAL" | "PRODUCTION" | "%future added value";
export type AppBuildEnvironmentType = "PROD" | "STAGING" | "%future added value";
export type AppBuildVersionBumpType = "AUTO" | "BUILD" | "MAJOR" | "MINOR" | "NONE" | "PATCH" | "%future added value";
export type KickoffAndroidAppBuildInput = {
  brandId: string;
  env: AppBuildEnvironmentType;
  releaseStatus: AppBuildAndroidReleaseStatusType;
  track: AppBuildAndroidTrackType;
  versionBump: AppBuildVersionBumpType;
};
export type InternBuildActionsPanelAndroidMutation$variables = {
  input: KickoffAndroidAppBuildInput;
};
export type InternBuildActionsPanelAndroidMutation$data = {
  readonly kickoffAndroidAppBuild: {
    readonly message: string;
    readonly pipelineId: string | null;
    readonly success: boolean;
  };
};
export type InternBuildActionsPanelAndroidMutation = {
  response: InternBuildActionsPanelAndroidMutation$data;
  variables: InternBuildActionsPanelAndroidMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "KickoffAndroidAppBuildMutationPayload",
    "kind": "LinkedField",
    "name": "kickoffAndroidAppBuild",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pipelineId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBuildActionsPanelAndroidMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBuildActionsPanelAndroidMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "657ff4b7d436366fe68cbe1b88fee93e",
    "id": null,
    "metadata": {},
    "name": "InternBuildActionsPanelAndroidMutation",
    "operationKind": "mutation",
    "text": "mutation InternBuildActionsPanelAndroidMutation(\n  $input: KickoffAndroidAppBuildInput!\n) {\n  kickoffAndroidAppBuild(input: $input) {\n    success\n    message\n    pipelineId\n  }\n}\n"
  }
};
})();

(node as any).hash = "7261db5a2aba192edee933f8d40bd952";

export default node;
